import React, { useState, useEffect } from 'react'
import "../../styles/componentsStyles/Browse/FullScreenView.scss"

// File viewer
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

// CODE RELATED TO PDF VIEWER 
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
    'pdfjs-dist/build/pdf.worker.min.js',
    import.meta.url,
).toString();
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
// CODE RELATED TO PDF VIEWER (react-pdf) END

const FullScreenView = ({ file }) => {
    // PDF VIEWER 
    const [numPages, setNumPages] = useState();
    const [pageNumber, setPageNumber] = useState(1);
    const [pageZoom, setPageZoom] = useState(1);
    const [scaledContent, setScaledContent] = useState(null);

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'ArrowLeft') {
                if (pageNumber >= 2) { setPageNumber(pageNumber - 1) }
            } else if (event.key === 'ArrowRight') {
                if (pageNumber < numPages) { setPageNumber(pageNumber + 1) }
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    });

    const handleZoomIn = () => {
        const newZoomLevel = pageZoom + 0.1; // Increase zoom level by 10%
        setPageZoom(Math.min(100, newZoomLevel)); // Limit zoom level to maximum 100%
    };

    const handleZoomOut = () => {
        const newZoomLevel = pageZoom - 0.1; // Decrease zoom level by 10%
        setPageZoom(Math.max(0.1, newZoomLevel)); // Limit zoom level to minimum 0%
    };

    useEffect(() => {
        const newScaledContent = (
            <Document file={file} loading="Loading file..." onLoadSuccess={onDocumentLoadSuccess} // Revoke data uri after image is loaded
                className='full-screen-view__thumbnail'>
                <Page pageNumber={pageNumber} width={500} scale={pageZoom} />
            </Document>
        );
        setScaledContent(newScaledContent); // Update scaledContent whenever zoomLevel changes
    }, [pageZoom, pageNumber]);

    return (
        <div className='full-screen-view'  >
            {/* Render the scaledContent only if it's defined */}
            {scaledContent && scaledContent}
            <div className="full-screen-view__pdf-page-navigation">
                <div className="full-screen-view__action-btn full-screen-view__nav-btn--prev" onClick={() => { if (pageNumber >= 2) { setPageNumber(pageNumber - 1) } }}><span class="material-symbols-outlined">
                    keyboard_arrow_left
                </span></div>
                <p className='full-screen-view__text' >
                    {pageNumber}/{numPages}
                </p>
                <div className="full-screen-view__action-btn full-screen-view__nav-btn--next" onClick={() => { if (pageNumber < numPages) { setPageNumber(pageNumber + 1) } }}><span class="material-symbols-outlined">
                    keyboard_arrow_right
                </span></div>
            </div>
            <div className="full-screen-view__page-zoom">
                <button onClick={handleZoomIn} className='full-screen-view__action-btn'><span class="material-symbols-outlined">
                    add
                </span></button>
                <p className="full-screen-view__text">{Math.trunc(pageZoom * 100)}%</p>
                <button onClick={handleZoomOut} className='full-screen-view__action-btn'><span class="material-symbols-outlined">
                    remove
                </span></button>
            </div>
        </div>
    )
}

export default FullScreenView